export default __webpack_public_path__ + "static/media/MMP_BB_Hospital Ind Guide_2025.c5b7fd8a.pdf";